//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconNavApps(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M3 11H11V3H3V11ZM5 5H9V9H5V5Z" fill="currentColor" /><path d="M3 21H11V13H3V21ZM5 15H9V19H5V15Z" fill="currentColor" /><path d="M13 21H21V13H13V21ZM15 15H19V19H15V15Z" fill="currentColor" /><path d="M18 6V3H16V6H13V8H16V11H18V8H21V6H18Z" fill="currentColor" /></svg>;
}
export default IconNavApps;